<template>
  <a-row>
    <a-col :span="4">
      <a-menu
        v-model:selectedKeys="state.activeKeys"
        mode="inline"
        style="width: 100%"
      >
        <a-menu-item key="1">站内通知</a-menu-item>
        <a-menu-item key="2">通知订阅管理</a-menu-item>
      </a-menu>
    </a-col>
    <a-col :span="20">
      <div class="ant-layout-content">
        <message-list v-if="state.activeKeys[0] === '1'" />
        <message-setting v-if="state.activeKeys[0] === '2'" />
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { reactive, toRefs, onMounted, defineExpose, inject } from 'vue'
import messageList from './list.vue'
import messageSetting from './setting.vue'
import MessageList from '@/views/NoticePublishCenter/components/messageCenter/list.vue'
import MessageSetting from '@/views/NoticePublishCenter/components/messageCenter/setting.vue'

export default {
  name: 'messageCenter',
  components: { MessageSetting, MessageList },

  setup() {
    const state = reactive({
      activeKeys: ['1']
    })

    return {
      state
    }
  }
}
</script>

<style scoped>
.ant-layout-content {
  padding: 10px 20px;
}
</style>
